import { useCallback, useState } from 'react';

import _ from 'lodash';

/**
 * The people ticked in a changes drawer (Pending Changes, Log History). They start as `defaultAuthorKeys`
 * and only filter that drawer's list; `onResetAuthorKeys` goes back to the default when the drawer reopens.
 */
const useDrawerAuthorKeys = defaultAuthorKeys => {
  const [authorKeys, setAuthorKeys] = useState(null);

  const onAuthorToggle = useCallback(
    authorKey =>
      setAuthorKeys(prevAuthorKeys => _.xor(prevAuthorKeys ?? defaultAuthorKeys, [authorKey])),
    [defaultAuthorKeys],
  );

  const onResetAuthorKeys = useCallback(() => setAuthorKeys(null), []);

  return {
    selectedAuthorKeys: authorKeys ?? defaultAuthorKeys,
    onAuthorToggle,
    onResetAuthorKeys,
  };
};

export default useDrawerAuthorKeys;
